// ── 소개 페이지 영상 자리 (2026-09-28) ─────────────────────────────────────────
//   src 없음 → "영상 준비 중" 상자 / 유튜브 주소 → 유튜브 영상 / 그 밖의 주소 → 영상 파일(video 태그).
//   상자는 16:9 비율로 고정해서, 영상이 들어와도 페이지 모양이 바뀌지 않는다.
import React from 'react';
import { Play } from 'lucide-react';

const BOX = 'relative w-full aspect-video overflow-hidden rounded-2xl border border-[var(--border)] bg-[var(--bg-subtle)]';

// youtube.com/watch?v=ID · youtu.be/ID · youtube.com/embed/ID · youtube.com/shorts/ID → ID
export function youtubeId(url) {
  const m = String(url || '').match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
}

export default function VideoSlot({ src, title }) {
  if (!src) {
    return (
      <div className={BOX}>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-[var(--text-muted)]">
          <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--bg-card)]">
            <Play size={20} />
          </span>
          <span className="text-[13px] font-semibold">영상 준비 중</span>
        </div>
      </div>
    );
  }
  const yt = youtubeId(src);
  if (yt) {
    return (
      <div className={BOX}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${yt}?rel=0`}
          title={title || '소개 영상'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }
  return (
    <div className={BOX}>
      <video className="absolute inset-0 h-full w-full object-cover" src={src} controls playsInline preload="metadata" />
    </div>
  );
}
